export function objToFormData (obj = {}, formData = new FormData(), key = '') {
    if (!([Array, File, Object].includes(obj.constructor))) {
        return formData;
    }

    // Handle File recursive
    if (obj instanceof File) {
        formData.append(key, obj);
        return formData;
    }

    const bool = (value) => typeof value === 'boolean' ? (value === true ? 1 : 0) : value;

    for (const prop in obj) {
        // Validate value type
        if (obj[prop] && !([String, Number, Boolean, Array, Object, File].includes(obj[prop].constructor))) {
            continue;
        }

        // Set deep index of prop
        const deepKey = key ? key + `[${prop}]` : prop;

        // Handle array
        if (Array.isArray(obj[prop])) {
            if (obj[prop].length) {
                obj[prop].forEach((item, index) => {
                    if (typeof item === 'object') {
                        objToFormData(item, formData, `${deepKey}[${index}]`);
                    } else {
                        formData.append(deepKey + `[${index}]`, bool(item))
                    }
                });
                continue;
            } else {
                formData.append(`${deepKey}`, '');
                continue;
            }
        }

        (typeof obj[prop] === 'object' && obj[prop] && obj[prop].constructor === Object)
            ? objToFormData(obj[prop], formData, deepKey) // Handle object
            : formData.append(deepKey, [undefined, null].includes(obj[prop]) ? '' : bool(obj[prop])) // Handle string, number, boolean
    }

    return formData;
}

